<template>
  <div class="h-5 w-5 flex items-center justify-center"
       :class="expired ? '' : 'cursor-pointer'"
       :style="{border: '2px solid ' + color, background: checked ? color : 'transparent'}"
        @click.prevent="selected"
  >
    <span v-if="checked" class="text-white">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
      </svg>
    </span>

    <span v-else-if="!checked && expired" class="font-bold" :style="{color: color}">-</span>
    <span v-else></span>

  </div>
</template>

<script>
export default {
  emits: ['select'],
  props: {
    checked: {
      required: true
    },
    color: {
      required: true
    },
    expired: {
      false: true,
      default: false
    }
  },

  methods: {
    selected(){
      if (this.expired) return
      this.$emit('select')
    }
  }
}
</script>
